module.exports = __webpack_public_path__ + "img/title.34252b31.png";